module.exports = __webpack_public_path__ + "static/img/kkonline.71bff90b.png";